import * as React from 'react';
import { connect } from 'react-redux';
import { StandardPageLayout } from 'ui/components/StandardPageLayout';
import { EnableLxLoginEnum, LxConfig, ROUTES } from '../../../global/constants';
import { RootState } from 'global/state';
import bind from 'bind-decorator';
import * as LoginActions from 'auth/actions';
import { showErrorMessage } from 'ui/components';
import { getLoggedInStatus } from 'auth/selectors';
import { Redirect } from 'react-router';

interface Props {
    isLoggedIn: boolean;
    loginUser: typeof LoginActions.login;
}

interface State {
    email: string;
    password: string;
}

@connect((state: RootState) => ({
    isLoggedIn: getLoggedInStatus(state),
}), {
    loginUser: LoginActions.login,
})
export class LXLoginView extends React.PureComponent<Props, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            email: '',
            password: '',
        };
    }

    public render() {
        if (this.props.isLoggedIn || !this.isLxLoginActive()) {
            return <Redirect to={ROUTES.Explore.HOME} push={true} />;
        }

        return (
            <StandardPageLayout>
                <form onSubmit={this.onSubmit} method='POST'>
                    <label>
                    Email:
                    <input name='email' type='text' value={this.state.email} onChange={this.onEmailChange} />
                    </label><br/>
                    <label>
                    Password:
                    <input name='password' type='password' value={this.state.password} onChange={this.onPasswordChange} />
                    </label><br/>
                    <input type='submit' value='Submit' />
                </form>
            </StandardPageLayout>
        );
    }

    @bind private isLxLoginActive() {
        return LxConfig.EnableLxLogin === EnableLxLoginEnum.Debug ||
                LxConfig.EnableLxLogin === EnableLxLoginEnum.Production;
    }

    @bind private onEmailChange(event: any) {
        this.setState({email: event.target.value});
    }

    @bind private onPasswordChange(event: any) {
        this.setState({password: event.target.value});
    }

    @bind private async onSubmit(event: any) {
        event.preventDefault();

        /// Build data for request
        const formData  = new FormData();
        formData.append('email', this.state.email);
        formData.append('password', this.state.password);

        let response;

        try {
            /// This response login the user on django and returns
            /// a `Set-Cookie` header to set the `labxchange_sessionid` cookie.
            ///
            /// By default the `Set-Cookie` doesn't works. It is nedeed the `credentials`
            /// param for it to work and save the cookie.
            /// Ref: https://stackoverflow.com/a/46481100
            response = await fetch(`${LxConfig.BackendBaseUrl}/api/v1/users/login/`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });
        }
        catch {
            /// When the servers returns an 500 error the frontend generates a CORS error
            /// because the backend does not send the Access-Control-Allow-Credentials header
            /// when unexpected errors occur
            showErrorMessage('An error occurred during login');
            return;
        }

        // TODO intl of the messages
        if (response.status === 200) {
            /// After the `labxchange_sessionid` cookie is set,
            /// we redirect to `/oauth2/authorize` to complete the login
            this.props.loginUser();
        }
        else if (response.status === 401) {
            const errorMessage = (await response.json()).error_message;
            /// "Too many failed login attempts. Try again later."
            if (errorMessage) {
                showErrorMessage(errorMessage);
            }
            else {
                showErrorMessage('Unable to login');
            }
        }
        else {
            showErrorMessage('Unable to login');
        }
    }
}
